import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/auth";
import { useEffect, useState } from "react";
import _, { last } from "lodash";
import { encyptData, isConatainsSymbol, isMainDomain } from "../../utils/AppUtils";
import { Formik } from "formik";
import * as Yup from "yup";
import {
  loginBroker,
  otpApiResClear,
  signUpApiReq,
  signUpApiResClear,
} from "../../redux/auth/actions";

const SignUpComp = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const authProvider = useAuth();

  const signUpRes = useSelector((state) => state.auth.signUpRes);

  const [isLoading, setIsLoading] = useState(false);
  const [isPassLength, setIsPassLength] = useState(false);
  const [isSymbol, setIsSymbol] = useState(false);

  const [initialValue, setInitialValue] = useState({
    name: "",
    email: "",
    brokerage: "",
    password: "",
  });

  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [brokerage, setBrokerage] = useState("");
  const [password, setPassword] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isEmailFocused, setisEmailFocused] = useState(false);
  const [valid, setValid] = useState(true);

  const [formError, setFormError] = useState("");

  const stripeFormSchema = Yup.object().shape({
    email: Yup.string().required("Please enter email"),
    password: Yup.string().required("Please enter password"),
  });

  const handleSubmit = (values) => {
    console.log("onSubmit1 ", values);
  };

  useEffect(() => {
    document.body.classList.add('overflow-hidden-desk');

    encyptData({});
    return () => {
      dispatch(signUpApiResClear());
      dispatch(otpApiResClear());
      document.body.classList.remove('overflow-hidden-desk');
    };
  }, []);

  const signUpApi = () => {

    if(_.isEmpty(name) || _.isEmpty(lastName) || _.isEmpty(email) || _.isEmpty(password)){
      return;
    }

    setIsLoading(true);
    
    let req = {
      // entity_type: "add-user-entity",
      first_name: name,
      last_name: lastName,
      email: email,
      broker_name: brokerage,
      password: password,
    };
    let encryptedReq = encyptData(req);
    if (valid) {
      dispatch(
        signUpApiReq({
          module: "signUpReq",
          postData: {
            data: encryptedReq,
          },
        })
      );
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(signUpRes)) {
      setIsLoading(false);
      console.log("signUpRes: ", signUpRes);
      if (signUpRes?.status === "success") {
        let email = signUpRes?.payload?.payload?.email;
        let userId = signUpRes?.payload?.payload?.user_id;
        navigate(`/sign-up?p=2&email=${email}&userId=${userId}`);
      } else {
        setFormError(signUpRes?.error?.message);
        setTimeout(() => {
          setFormError("");
        }, 5000);
      }
    }
  }, [signUpRes, dispatch]);

  const validateEmail = (email) => {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{3,})$/i;
    return re.test(String(email).toLowerCase());
  };

  //   const validateEmail = (email) => {
  //     // Email validation regex pattern
  //     const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  //     setValid(emailRegex.test(email));
  // };

  const handleEmailChange = (e) => {
    const emailInput = e.target.value;
    setEmail(emailInput);
  };

  const handleEmailBlur = () => {
    setValid(validateEmail(email));
    setisEmailFocused(false);
  };

  const handleEmailFocus = () => {
    setisEmailFocused(true);
  };

  const [termnconditions, setTermnconditions] = useState(false);
  const myFunction = () => {
    var x = document.getElementById("passInput");
    var y = document.getElementById("eyeImg");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/view.png";
    } else {
      x.type = "password";
      y.src = "/images/private.png";
    }
  };

  return (
    <>
      <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt sign-up-frm">
        <div className="login-text">
          <div
            className="text-center lgo-box cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img src="images/logo/Untitled-6.png" alt="images" />
          </div>
          <h2 className="text-center logtitle">{t("Create an account")}</h2>
          <p className="ms-2-message text-center">
            Start your free subscription.
          </p>
          <div>
            <Formik
              initialValues={initialValue}
              validationSchema={stripeFormSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {(formik) => {
                const { handleSubmit } = formik;

                return (
                  <form onSubmit={handleSubmit}>
                    <div className="flex-row d-flex">
                      <div className="input-text me-2">
                        <label htmlFor="password" className="input__label">
                          {t("First Name*")}
                        </label>
                        <input
                          className="input__field"
                          name="name"
                          type="text"
                          value={name}
                          onChange={(evt) => setName(evt.target.value)}
                          placeholder="Enter your first name"
                          required
                          autoComplete="off"
                        />
                      </div>
                      <div className="input-text ms-2">
                        <label htmlFor="password" className="input__label">
                          {t("Last Name*")}
                        </label>
                        <input
                          className="input__field"
                          name="name"
                          type="text"
                          value={lastName}
                          onChange={(evt) => setLastName(evt.target.value)}
                          placeholder="Enter your last name"
                          required
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Email*")}
                      </label>
                      <input
                        className="input__field"
                        name="email"
                        type="email"
                        value={email}
                        onChange={handleEmailChange}
                        onBlur={handleEmailBlur}
                        onFocus={handleEmailFocus}
                        placeholder="Enter your email"
                        required
                        autoComplete="off"
                      />
                      <div className="login-msg">
                        {formError ? (
                          <div
                            className="mt-1 form-error"
                            style={{ color: "red" }}
                          >
                            {formError}
                          </div>
                        ) : !valid && !isEmailFocused ? (
                          <div
                            className="mt-1 form-error"
                            style={{ color: "red" }}
                          >
                            Please Enter a Valid Email
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Brokerage")}
                      </label>
                      <input
                        className="input__field"
                        name="brokerage"
                        type="text"
                        value={brokerage}
                        onChange={(evt) => setBrokerage(evt.target.value)}
                        placeholder="Enter your brokerage name"
                        autoComplete="off"
                      />
                    </div>
                    <div className="input-text ">
                      <label htmlFor="password" className="input__label">
                        {t("Password*")}
                      </label>
                      <div className="position-relative">
                        <input
                          id="passInput"
                          className="input__field"
                          name="password"
                          type="password"
                          value={password}
                          placeholder="Create a password"
                          required
                          autoComplete="off"
                          onChange={(e) => {
                            console.log("onChange: ", e.target.value);
                            if (
                              !(
                                _.isEmpty(e.target.value) ||
                                e.target.value?.length < 8
                              )
                            )
                              setIsPassLength(true);
                            else setIsPassLength(false);

                            if (
                              !_.isEmpty(e.target.value) &&
                              isConatainsSymbol(e.target.value)
                            )
                              setIsSymbol(true);
                            else setIsSymbol(false);

                            setPassword(e.target.value);
                          }}
                        />
                        {true && (
                          <div
                            className="show-pass"
                            onClick={() => {
                              myFunction();
                            }}
                          >
                            <img
                              id="eyeImg"
                              src="/images/private.png"
                              alt="view"
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className={"validation-pass"}>
                      <div
                        className={`valid-text ${isPassLength ? "active" : ""}`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="20"
                            height="20"
                            rx="10"
                            fill={"#D0D5DD"}
                          />
                          <path
                            d="M6.25 10L8.75 12.5L13.75 7.5"
                            stroke="white"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Must be at least 8 characters
                      </div>
                      <div className={`valid-text ${isSymbol ? "active" : ""}`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <rect
                            width="20"
                            height="20"
                            rx="10"
                            fill={"#D0D5DD"}
                          />
                          <path
                            d="M6.25 10L8.75 12.5L13.75 7.5"
                            stroke="white"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Must contain one special character
                      </div>
                      {false && (
                        <div className="">
                          <div className="form-check cursor-pointer">
                            <input
                              className="form-check-input cursor-pointer"
                              type="checkbox"
                              checked={termnconditions}
                              onChange={() =>
                                setTermnconditions(!termnconditions)
                              }
                            />
                            <label className="valid-text" for="termofusein">
                              Terms and Conditions
                            </label>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="btn-footer-sign">
                      <button
                        className={`default-btn signinBtn mt-4 ${isLoading ? "isLogin" : ""
                          }`}
                        onClick={() => {
                          if (!isPassLength || !isSymbol) {
                            return;
                          }
                          signUpApi();
                        }}
                      >
                        {isLoading ? (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        ) : (
                          t("Get Started")
                        )}
                      </button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          </div>

          <div className="don-have-account">
            Already have an account?{" "}
            <strong
              onClick={() => {
                if(isMainDomain()){
                  navigate("/verify-user")// navigate('/login')
                }else{
                  navigate("/")
                } 
                
                // navigate("/login");
              }}
            >
              Sign in
            </strong>
          </div>
          {false && <div className="bying-brokarage">
            Buying for your brokerage, instead?
          </div>}
        </div>
      </div>
    </>
  );
};

export default SignUpComp;
